"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Input = _interopRequireDefault(require("../Input/Input"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const InputNumber = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'inputNumber',
      allowexponent = true,
      allowdecimal = true,
      allownegativenumber = true
    } = props,
    rest = __rest(props, ["className", "allowexponent", "allowdecimal", "allownegativenumber"]);
  const handleKeyPress = e => {
    if (!allowexponent && e.key === 'e') {
      e.preventDefault();
    }
    if (!allownegativenumber && e.key === '-') {
      e.preventDefault();
    }
    if (!allowdecimal && e.key === '.') {
      e.preventDefault();
    }
  };
  return (0, _jsxRuntime.jsx)(_Input["default"], (0, _extends2["default"])({
    ref: ref,
    type: "number",
    className: className,
    onKeyPress: handleKeyPress
  }, rest));
});
var _default = exports["default"] = InputNumber;